export default (
  workflowData: Record<string, unknown>[]
): Record<string, unknown> => {
  let flattenWorkflowData: Record<string, unknown> = {};
  for (const data of workflowData) {
    flattenWorkflowData = {
      ...flattenWorkflowData,
      ...data
    };
  }
  return flattenWorkflowData;
};
